import { useCallback, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { PearlFormAssistant } from "../PearlFormAssistant"
import { PearlHeader } from "../PearlHeader"
import { PearlSideBox } from "../PearlSideBox"
import { PearlProps } from "./types"

export function Pearl({ name, children }: PearlProps) {
  const { pathname } = useLocation()
  const { accountAspect } = useAccountAspect()
  const ref = useRef<HTMLDivElement>(null)

  const handlePearlRender = useCallback(() => {
    const { innerText } = ref?.current ?? {}

    if (innerText) {
      // There's a 512 Bytes size limit to this JSON in Pendo
      window?.pendo?.track(`pearl-${name}`, {
        text: innerText?.slice(0, 250) ?? "",
        pathname,
        accountAspect,
      })
    }
  }, [accountAspect, name, pathname])

  useEffect(() => {
    handlePearlRender()
  }, [handlePearlRender])

  return (
    <div data-testid={`pearl-${name}`} ref={ref}>
      {children}
    </div>
  )
}

Pearl.Header = PearlHeader
Pearl.SideBox = PearlSideBox
Pearl.FormAssistant = PearlFormAssistant
